import React, { useState } from "react";
import { Link } from "../../components/LinkIcon";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { tryNow } from "../../utils";
import { useInterval } from "react-use";
import { Title } from "../../components/NewTitle";
import classNames from "classnames";

export const SolutionSceneSwitchScreen = (props) => {
  const [selectIndex, setSelectIndex] = useState(0);
  const { featureList, hasDoc } = props;
  const { t } = useTranslation();

  useInterval(() => {
    if (selectIndex < featureList.length - 1) {
      setSelectIndex(selectIndex + 1);
    } else {
      setSelectIndex(0);
    }
  }, 5000);
  const [element, setElement] = useState(0);
  const nextFun = () => {
    if (element >= featureList.length - 1) {
      setElement(0);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 0) {
      setElement(featureList.length - 1);
    } else {
      setElement(element - 1);
    }
  };
  const renderSwitchScreenPC = () => {
    return (
      <section className="solution-scene-switch-screen-pc">
        <div className="solution-scene-switch-screen-left">
          <div className="dot-warpper">
            {featureList.map((item, index) => {
              const cls = classNames({
                item: true,
                checked: selectIndex === index,
              });
              return <div className={cls}></div>;
            })}
          </div>
          <div className="block-warpper">
            {featureList.map((item, index) => {
              const cls = classNames({
                selected: selectIndex === index,
                block: true,
              });
              return (
                <div className={cls}>
                  <div className="subtitle">{item?.subLabel}</div>
                  <div className="content">{item?.content}</div>
                  {hasDoc && (
                    <Link href={item.docLink} target="_blank">
                      {t("common.button.linkDoc")}
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="solution-scene-switch-screen-right">
          {featureList?.map((item, index) => (
            <img
              style={
                selectIndex === index
                  ? { display: "block" }
                  : { display: "none" }
              }
              src={item?.imgUrl}
              alt="authing"
            />
          ))}
        </div>
      </section>
    );
  };

  const renderSwitchScreenMobile = () => {
    return (
      <div className="solution-scene-switch-screen-mobile">
        <div
          className="last-button"
          onClick={() => {
            lastFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
        <div className="solution-scene-switch-screen-content">
          {featureList.map((item, index) => {
            if (element === index) {
              return (
                <>
                  <div className="value-text-title">{item.subLabel}</div>
                  <div className="value-text-context">{item.content}</div>
                  <div style={{ textAlign: "center" }}>
                    {hasDoc && (
                      <Link href={item.docLink} target="_blank">
                        {t("common.button.linkDoc")}
                      </Link>
                    )}
                  </div>
                  <div className="value-text-img">
                    <img src={item.imgUrl} alt="authing" />
                  </div>
                </>
              );
            } else {
              return null;
            }
          })}
        </div>
        <div
          className="next-button"
          onClick={() => {
            nextFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
      </div>
    );
  };
  return (
    <>
      {renderSwitchScreenPC()}
      {renderSwitchScreenMobile()}
    </>
  );
};
